import { NgModule } from '@angular/core';
import { NpButton } from './button';

/**
 * @ignore
 */
@NgModule({
    imports: [
    ],
    declarations: [NpButton],
    exports: [NpButton]
})
export class NpButtonModule { }
